import { LogOut } from 'lucide-react';
import { Button } from '../../../ui/common-ui/button';

interface LogoutButtonProps {
  onLogout: () => void;
}

export function LogoutButton({ onLogout }: LogoutButtonProps) {
  return (
    <div className="glass-panel rounded-xl p-2 shadow-lg">
      <Button
        variant="outline"
        size="icon"
        onClick={onLogout}
        className="rounded-xl"
        title="Back to selection"
      >
        <LogOut className="w-4 h-4" />
      </Button>
    </div>
  );
}
